import React, {useState} from "react";
import {Modal, Box} from "@mui/material";
import {FaTimes, FaChevronRight, FaCoins, FaBuilding, FaMapMarkerAlt} from "react-icons/fa";
import Moment from "react-moment";
import "../app.scss";
import {AiFillCheckCircle} from "react-icons/ai";
import {apiUrl} from "../config";
import AttachmentViewer from "../AttachmentViewer";

const JobView = ({item}) => {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(null);

    const openJob = (id) => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        fetch(apiUrl + "public-jobs-view/" + id, requestOptions)
            .then(response => response.json())
            .then(result => {
                setData(result.data);
                setOpen(true);
            })
            .catch(error => console.log("error", error));
    };

    return (
        <>
            <div className="job-card" onClick={() => openJob(item.id)}>
                <div className="job-card-header">
                    <div className="job-title">
                        {item.title}
                    </div>
                    <div className="job-arrow">
                        <FaChevronRight/>
                    </div>
                </div>
                <div className="job-company">
                    <span className="job-company-name">{item.name}</span>
                    {parseInt(item.is_verified) === 1 && (
                        <AiFillCheckCircle className="job-company-verified"/>
                    )}
                </div>
                <div className="job-tags">
                    {item.location && (
                        <span className="job-tag">
                            {item.location}
                        </span>
                    )}
                    {item.type && (
                        <span className="job-tag">
                            {item.type}
                        </span>
                    )}
                </div>
                <div className="job-meta">
                    <span className="job-salary">
                        <FaCoins className="job-salary-icon"/>
                        {item.salary_range}
                    </span>
                    <span className="job-time">
                        <Moment fromNow>{item.created_at}</Moment>
                    </span>
                </div>
            </div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                className="jobModal"
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box className="jobViewContent">
                    {data !== null && (
                        <>
                            <div className="jobView-header">
                                <div>
                                    <div className="jobView-title">{data.title}</div>
                                    <div className="jobView-meta">
                                        <span>
                                            Posted <Moment fromNow>{data.created_at}</Moment>
                                        </span>
                                        {data.expired_at && (
                                            <span>
                                                • Closing on{" "}
                                                <Moment format="DD MMMM YYYY">
                                                    {data.expired_at}
                                                </Moment>
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="jobView-close"
                                    onClick={() => setOpen(false)}
                                >
                                    Close
                                </button>
                            </div>

                            <div className="jobView-body">
                                <div className="jobView-summary">
                                    <div className="jobView-summary-item">
                                        <div className="jobView-summary-label">
                                            <FaBuilding className="jobView-summary-icon"/>
                                            Company
                                        </div>
                                        <div className="jobView-summary-value">
                                            {data.company_name || "Not specified"}
                                        </div>
                                    </div>
                                    <div className="jobView-summary-item">
                                        <div className="jobView-summary-label">
                                            <FaMapMarkerAlt className="jobView-summary-icon"/>
                                            Location
                                        </div>
                                        <div className="jobView-summary-value">
                                            {data.location || "Not specified"}
                                        </div>
                                    </div>
                                    <div className="jobView-summary-item">
                                        <div className="jobView-summary-label">
                                            <FaCoins className="jobView-summary-icon"/>
                                            Salary
                                        </div>
                                        <div className="jobView-summary-value">
                                            {data.salary_range || "Not specified"}
                                        </div>
                                    </div>
                                </div>

                                <div className="jobView-section-title">Description</div>
                                <div className="jobView-description">
                                    <div
                                        className="jobView-description-content"
                                        dangerouslySetInnerHTML={{
                                            __html: data.description
                                        }}
                                    />
                                </div>

                                <ul className="jobView-info-list">
                                    {data.application_form && data.application_form.length > 0 && (
                                        <li className="jobView-info-item">
                                            <span className="jobView-info-bullet"/>
                                            <div className="jobView-info-text">
                                                This job requires a Job Application for to be submitted,{" "}
                                                <a
                                                    href={data.application_form}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Click here to download.
                                                </a>
                                            </div>
                                        </li>
                                    )}
                                    {data.notification_email && (
                                        <li className="jobView-info-item">
                                            <span className="jobView-info-bullet"/>
                                            <div className="jobView-info-text">
                                                You can send job applications to{" "}
                                                <a href={`mailto:${data.notification_email}`}>
                                                    {data.notification_email}
                                                </a>
                                            </div>
                                        </li>
                                    )}
                                    {data.external_application_link && (
                                        <li className="jobView-info-item">
                                            <span className="jobView-info-bullet"/>
                                            <div className="jobView-info-text">
                                                This employer accepts applications from their own/external
                                                hiring portal,{" "}
                                                <a
                                                    href={data.external_application_link}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Click here to visit.
                                                </a>
                                            </div>
                                        </li>
                                    )}
                                    {data.attachment && data.attachment.length > 0 && (
                                        <li className="jobView-info-item">
                                            <span className="jobView-info-bullet"/>
                                            <div className="jobView-info-text">
                                                This job contains a PDF job ad,{" "}
                                                <a
                                                    href={data.attachment}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Click here to view.
                                                </a>
                                            </div>
                                        </li>
                                    )}
                                </ul>

                                <div className="jobView-callout mb-4">
                                    <a
                                        href="https://jobsicle.mv/download"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="font-bold text-primary"
                                    >
                                        Download
                                    </a>{" "}
                                    the Jobsicle mobile app to get daily new job alerts,
                                    build your Talent Profile, and apply online in a few taps.
                                </div>
                            </div>
                        </>
                    )}
                </Box>
            </Modal>
        </>
    );
};

export default JobView;
